import Vue from 'vue'
import Vuex from 'vuex'

import tagCanvas from './tagcanvas'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    tagCanvas
  }
})
